var _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3Bg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_5201_8186",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 125C0 55.9644 55.9644 0 125 0C194.036 0 250 55.9644 250 125C250 194.036 194.036 250 125 250C55.9644 250 0 194.036 0 125Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 125C0 55.9644 55.9644 0 125 0C194.036 0 250 55.9644 250 125C250 194.036 194.036 250 125 250C55.9644 250 0 194.036 0 125Z",
    fill: "#FFFDF8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M125 246C58.1735 246 4 191.826 4 125H-4C-4 196.245 53.7553 254 125 254V246ZM246 125C246 191.826 191.826 246 125 246V254C196.245 254 254 196.245 254 125H246ZM125 4C191.826 4 246 58.1735 246 125H254C254 53.7553 196.245 -4 125 -4V4ZM125 -4C53.7553 -4 -4 53.7553 -4 125H4C4 58.1735 58.1735 4 125 4V-4Z",
    fill: "#2D2926",
    mask: "url(#path-1-inside-1_5201_8186)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Bg);
export default __webpack_public_path__ + "static/media/3-bg.9429c39c2eefa97a84cacd8efba26aee.svg";
export { ForwardRef as ReactComponent };